// extracted by mini-css-extract-plugin
export var content = "Merchandise-module--content--52868";
export var heading = "Merchandise-module--heading--b66c5";
export var imageWall = "Merchandise-module--imageWall--e46a0";
export var imageWrapper = "Merchandise-module--imageWrapper--1d03b";
export var mercImage = "Merchandise-module--mercImage--8ca47";
export var wrapper = "Merchandise-module--wrapper--80c23";